import { InitialState } from '@libs/focus-frontend-types/src/@teamleader/api/initialState';

const mapInitialState = (initialState: InitialState) => {
  return {
    config: {
      API_URL: environment.API_URL,
      PAYMENTS_URL: environment.PAYMENTS_URL,
      OAUTH_SESSION_GRANT_TYPE: 'TL.authentication.oauth2.session_grant',
      OAUTH_CLIENT_ID: 'web_app',
      OAUTH_CLIENT_SECRET: '',
      ACCOUNT_ID: initialState.account.intId,
      EMPLOYEE_ID: initialState.user.intId,
      USER_UUID: initialState.user.uuid,
      DEBUG_RECORD_SESSION_ENABLED: initialState.config.debugRecordSessionEnabled,
      IS_USING_PAYMENTS_PLATFORM: initialState.account.isUsingPaymentsPlatform,
      MAX_TOTAL_FILESIZE_EMAIL_ATTACHMENTS_IN_MEGA_BYTES:
        initialState.config.maxTotalFilesizeEmailAttachmentsInMegaBytes,
    },
    global: {
      countries: initialState.global.countries,
      languages: initialState.global.languages,
      stripeKey: initialState.config.stripeKey,
      trendsTopContactCost: initialState.global.trendsTopContactCost,
    },
    user: {
      avatarUrl: initialState.user.avatarUrl,
      uuid: initialState.user.uuid,
      email: initialState.user.email,
      firstName: initialState.user.firstName,
      lastName: initialState.user.lastName,
      features: initialState.user.features,
      permissions: initialState.user.permissions,
      accountId: initialState.account.intId,
      employeeId: initialState.user.intId,
      defaultCountry: initialState.user.defaultCountry,
      popularCountries: initialState.user.popularCountries,
      featureFlags: initialState.user.featureFlags,
      featureFlagsLegacy: initialState.user.featureFlagsLegacy,
      departmentCountries: initialState.user.departmentCountries,
      isAdministrator: initialState.user.isAdmin,
      isAllowedToExportExcel: initialState.user.isAllowedToExportExcel,
      hasLimitedDealsAccess: initialState.user.hasLimitedDealsAccess,
      hasLimitedCrmAccess: initialState.user.hasLimitedCrmAccess,
      externalFilePlatformType: initialState.user.externalFilePlatformType,
      preferences: {
        language: initialState.user.languageIETF,
        timeZone: initialState.account.timeZone,
        dateFormat: {
          short: initialState.user.preferences.dateFormat.short,
          medium: initialState.user.preferences.dateFormat.medium,
          long: initialState.user.preferences.dateFormat.long,
        },
        numberFormat: {
          thousandsSeparator: initialState.user.preferences.numberFormat.thousandsSeparator,
          decimalSeparator: initialState.user.preferences.numberFormat.decimalSeparator,
        },
        webApp: initialState.user.preferences.webApp,
      },
      canAccessInAppSupportChat: initialState.user.canAccessInAppSupportChat,
      canAccessInAppSalesChat: initialState.user.canAccessInAppSalesChat,
      canAccessTimeTracking: initialState.user.canAccessTimeTracking,
      canAccessAutomaticReminder: initialState.user.canAccessAutomaticReminder,
      canAccessPricelist: initialState.user.canAccessPricelist,
      accessibleModules: initialState.user.accessibleModules,
    },
    trackingEnabled: initialState.config.trackingEnabled,
    account: {
      featureFlags: initialState.account.featureFlags,
      country: initialState.account.country,
      createdAt: initialState.account.createdAt,
      activatedAt: initialState.account.activatedAt,
      trialEndsAt: initialState.account.trialEndsAt,
      currency: initialState.account.currency,
      packageType: initialState.account.packageType,
      isTrial: Boolean(initialState.account.isDemo),
      isExpiredDemo: initialState.account.isExpiredDemo,
      isSandbox: initialState.account.isSandbox,
      timeZone: initialState.account.timeZone,
      isVoipActive: initialState.account.isVoipActive,
      bookkeeping: initialState.account.bookkeeping,
      isBookkeepingExternalIdShownForCustomers: initialState.account.isBookkeepingExternalIdShownForCustomers,
      applicationLanguage: initialState.account.applicationLanguage,
      isDistributorChannel: initialState.account.isDistributorChannel,
    },
  };
};

export default mapInitialState;
